import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import { Navbar } from 'react-bootstrap';
// import logoLight from 'assets/img/icons/favicon-CTCP-blue.svg';
// import logoLightLong from 'assets/img/icons/logotipo-horizontal-ctcp.svg';
import siglaCtcpHorizontalAzul from 'assets/img/icons/sigla-ctcp-horizontal-azul.svg';
// import logoLight from 'assets/img/icons/logotipo-horizontal-ctcp.svg';
// import logoDark from 'assets/img/icons/logotipo-horizontal-ctcp.svg';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { Link } from 'react-router-dom';

// import NavbarToggleButton from './NavbarToggleButton';

const NavbarBrand = () => {
  const {
    config: { navbarTopShape, navbarPosition }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();

  return (
    <>
      <div className="navbar-logo">
        {/* {breakpoints.down('lg') && <NavbarToggleButton />} */}
        <Navbar.Brand
          as={Link}
          to="/dashboard"
          className={classNames({
            'me-1 me-sm-3':
              navbarTopShape === 'slim' || navbarPosition === 'horizontal'
          })}
        >
          {navbarTopShape === 'slim' ? (
            <>
              CTCP{' '}
              <span className="text-body-highlight d-none d-sm-inline">
                Gestão
              </span>
            </>
          ) : (
            <div className="d-flex align-items-center">
              {breakpoints.down('lg') ? (
                <img
                  src={siglaCtcpHorizontalAzul}
                  alt="phoenix"
                  width={90} /*width={120}*/
                />
              ) : (
                <img src={siglaCtcpHorizontalAzul} alt="phoenix" width={105} />
              )}
              {/* <p className="logo-text ms-2 d-none d-sm-block"></p> */}
            </div>
          )}
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
